import {
    GET_STRELLATV_SUCCESS,
    GET_STRELLATV_FAIL,
} from '../actions/types';

const initialState = {
    strellatv: null,
};

export default function Home(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_STRELLATV_SUCCESS :
            return {
                ...state,
                strellatv: payload.strella,
            }

        case GET_STRELLATV_FAIL:
            return {
                ...state
            }

        default:
            return state
    }
}


